import { createSlice } from '@reduxjs/toolkit';
import { isPlainObject } from 'lodash';
import { TSiteTemplate } from '../../types';
import { TSiteState } from '../types';
import { ApiRequestSucceed } from '../saga/api/actions';
import { templateCollectionMutationSchema } from '../../utils/mutationSchema/templateCollectionMutationSchema';

const COLLECTION_WHITELIST: Record<string, RegExp[]> = {
  site: [
    /^pages$/,
    /^templates$/,
    /^icons$/,
    /^expressions$/,
    /^locales$/,
    /^settings$/,
    /^dictionaries$/,
  ],
};

const siteSlice = createSlice({
  name: 'site',
  initialState: {
    pages: {},
    templates: {},
    icons: {},
    expressions: {},
    settings: {},
    locales: {},
    dictionaries: {},
  } as TSiteState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(ApiRequestSucceed, (state, { payload }) => {
      if (!isPlainObject(payload.data)) return;

      const data = payload.data as Record<string, Record<string, unknown>>;
      const newSite = data.site;
      if (!newSite) return;

      const patterns = COLLECTION_WHITELIST.site;
      const filtered = Object.fromEntries(
        Object.entries(newSite).filter(([key]) => patterns.some(re => re.test(key)))
      );

      const templates = filtered.templates as Record<string, TSiteTemplate> | undefined;
      if (templates) {
        filtered.templates = templateCollectionMutationSchema(templates);
      }

      Object.assign(state, filtered);
    });
  },
});

export default siteSlice.reducer;
